// Base de conhecimento do painel, via CRM Lukos (@crm/api -> proxy /suporte/*).
const CRM_API_URL = (import.meta.env.VITE_CRM_API_URL || 'http://localhost:3336').replace(/\/$/, '');

export interface BaseConhecimentoItem {
  id: number | string;
  titulo?: string;
  nome?: string;
  descricao?: string;
  [key: string]: unknown;
}

export interface Categoria {
  id?: number | string;
  idCategoria?: number | string;
  nome?: string;
  descricao?: string;
  [key: string]: unknown;
}

export interface Subcategoria {
  id?: number | string;
  idSubCategoria?: number | string;
  nome?: string;
  [key: string]: unknown;
}

async function crmGet(path: string, token: string): Promise<any> {
  const response = await fetch(`${CRM_API_URL}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(body?.error || 'Erro ao consultar o CRM');
  }
  return body;
}

function extrairLista(data: any): any[] {
  if (Array.isArray(data)) return data;
  return data?.data ?? data?.items ?? data?.resultado ?? [];
}

export const crmKnowledgeBase = {
  async listarCategorias(token: string): Promise<Categoria[]> {
    const data = await crmGet('/api/suporte/categorias', token);
    return extrairLista(data);
  },

  async listarSubcategorias(idCategoria: number | string, token: string): Promise<Subcategoria[]> {
    const data = await crmGet(`/api/suporte/subcategorias?idCategoria=${encodeURIComponent(String(idCategoria))}`, token);
    return extrairLista(data);
  },

  async listar(token: string, q?: string): Promise<BaseConhecimentoItem[]> {
    const query = q ? `?q=${encodeURIComponent(q)}` : '';
    const data = await crmGet(`/api/suporte/base-conhecimento${query}`, token);
    return extrairLista(data);
  },

  async porSubcategoria(idSubcategoria: number | string, token: string): Promise<BaseConhecimentoItem[]> {
    const data = await crmGet(`/api/suporte/base-conhecimento/por-subcategoria/${encodeURIComponent(String(idSubcategoria))}`, token);
    return extrairLista(data);
  },
};

export default crmKnowledgeBase;
